import { DragEvent } from "react";

/** Ignore bubbled dragleave events caused by moving between list children. */
export function isDragLeavingContainer(
  event: Pick<
    DragEvent<HTMLElement>,
    "currentTarget" | "relatedTarget" | "clientX" | "clientY"
  >,
): boolean {
  const { currentTarget, relatedTarget, clientX, clientY } = event;
  if (relatedTarget instanceof Node) {
    return !currentTarget.contains(relatedTarget);
  }

  // Native drag events can omit relatedTarget. Hit-test instead of treating
  // every child transition as an exit (which would collapse the drop preview).
  const hoveredElement = currentTarget.ownerDocument.elementFromPoint(
    clientX,
    clientY,
  );
  return !hoveredElement || !currentTarget.contains(hoveredElement);
}
